<template>
  <ion-modal
    ref="modal"
    :is-open="props.isOpen"
    :presenting-element="props.presentingElement"
    :style="{
      '--backdrop-opacity': 0.9,
    }"
    class="will-change-transform"
    can-dismiss
    @didDismiss="emit('dismiss', false)"
    @willPresent="onModalWillPresent"
    @willDismiss="onModalWillDismiss"
  >
    <ion-nav id="order-modal-nav" ref="navRef" :root="OrderModalHome" />
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal, IonNav } from '@ionic/vue'
import { type JSX as IonicJSX } from '@ionic/core'
import { provide, computed, ref } from 'vue'
import useAppEventBus from '~/composables/useAppEventBus'
import OrderModalHome from './OrderModalHome/index.vue'

const emit = defineEmits<{
  'dismiss': [value: boolean]
  'update': [payload: {
    orderId: string,
    objectId?: string,
  }]
}>()
const props = withDefaults(defineProps<{
  presentingElement: HTMLElement | null
  isOpen: boolean
  orderId: string | null
  objectId: string | null
}>(), {
  presentingElement: null,
  isOpen: false,
  orderId: null,
  objectId: null,
})

provide(
  'isOpen',
  computed(() => props.isOpen),
)
provide(
  'orderId',
  computed(() => props.orderId),
)
provide(
  'objectId',
  computed(() => props.objectId),
)
provide(
  'navRef',
  computed(() => navRef?.value?.$el || null),
)

const navRef = ref<InstanceType<typeof IonNav> | null>(null)
const appBus = useAppEventBus()

appBus.on((event) => {
  if (event.type === 'order-modal-dismiss') {
    return emit('dismiss', false)
  } else if (event.type === 'order-modal-update') {
    return emit('update', event.payload)
  }
})

const onModalWillPresent: IonicJSX.IonModal['onIonModalWillPresent'] = ($event) => {
  $event.target.presentingElement?.classList.add('pushed-back')
}

const onModalWillDismiss: IonicJSX.IonModal['onIonModalWillDismiss'] = ($event) => {
  $event.target.presentingElement?.classList.remove('pushed-back')
}
</script>
